export enum TosterMsgType {
  ERROR,
  SUCCESS,
  WARNING
}

export enum OtpStatus {
  sent,
  verified,
  resent,
  init,
}

export enum EmiStatus {
  init,
  loaded,
  loading,
}

export interface ToasterData {
  msg: string,
  type: TosterMsgType,
  isHide: Boolean,
  callBack?:any,
}


export interface DialogBox {
  isDisbursed:boolean, 
  isValidating:boolean,
  title: string,
  text1: string,
  text2: string,
  text3: string,
  callBack: any,
  onClose: any,
  showNoBtn: boolean,
  showYesBtn: boolean,
  show: boolean,
  noBtnTxt?: string,
  yesBtnTxt?: string,
  icon?:string,
}

export interface EmpStatus {
  id: string,
  status: string,
}

export interface EmployeeDesignation{
                id: number,
                value: string,
                image64: string,
                order_id: number,
}


export interface SnackbarData {
  message: string,
  navigation: any,
  isRepeat:boolean,
}

export interface RelationsData {
  id: number,
  type: number,
  value: string,
}

export interface FixedTenure {
  emiType: string,
  institutionId: string,
  interestRate: number,
  refInstitutionId: string,
  subvention: number,
  courseId: string,
  tenor: number,
  customerRoi: number,
  
}

export interface TenureDetails {
  index: number,
  emi: number,
  customerRoi: number,
  emiStatus: EmiStatus,
  selectedTenor:FixedTenure,
  amount: number,
  emiBeforeMoratorium: number,
}

export interface BankDetails{
  id: number,
  accountId:string,
  name: string,
  accountNo: string,
  bankName:any,
  ifsc: string,
  bankConfirmation: Boolean,
  isReadOnly:boolean,
  isIfscReadonly:boolean,
}

export interface WaitingScreenModel{
  status: string, 
  isShow:boolean,
  isHome:boolean,
  
}

export interface PermissionsDialog{
  show:boolean, 
  title:string, 
  contentText:string,
}